import React from "react";

export default function MerchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: "20px",
        height: "20px",
        marginLeft: "0.3rem",
      }}
      fill="#fcfcfc"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <line
        x1="128"
        y1="64"
        x2="128"
        y2="192"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <polyline
        points="104 40 128 64 152 40"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
      <polyline
        points="104 216 128 192 152 216"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
      <line
        x1="72.6"
        y1="96"
        x2="183.4"
        y2="160"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <polyline
        points="39.8 104.8 72.6 96 63.8 63.2"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
      <polyline
        points="192.2 192.8 183.4 160 216.2 151.2"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
      <line
        x1="72.6"
        y1="160"
        x2="183.4"
        y2="96"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <polyline
        points="63.8 192.8 72.6 160 39.8 151.2"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
      <polyline
        points="216.2 104.8 183.4 96 192.2 63.2"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
    </svg>
  );
}
